/**
 * Supabase Client for Frontend
 * Handles authentication and database access
 */

import { createClient } from '@supabase/supabase-js';

// Get and normalize Supabase URL (remove trailing slash if present)
const rawSupabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseUrl = rawSupabaseUrl.replace(/\/$/, ''); // Remove trailing slash
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase credentials not found!');
  console.error('Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file');
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
      }
    })
  : null;





